module.exports = __webpack_public_path__ + "static/media/Yoyo_3121.38acb426.jpg";